<fury-page-layout mode="card">
    <div [@fadeInUp]>
        <div [style.display]="loader  ? 'block' : 'none'">
            Please wait...
        </div>
    <div [style.display]="!loader  ? 'block' : 'none'">
        <div class="rangeselectorprt">
            <div class="daterange">
                <mat-form-field class="example-form-field" appearance="outline">
                <mat-label>Date Range</mat-label>
                    <mat-date-range-input
                    [formGroup]="campaignOne"
                    [rangePicker]="campaignOnePicker"
                    [max]="today">
                    <input matStartDate placeholder="Start date" formControlName="start" #dateRangeStart>
                    <input matEndDate placeholder="End date" formControlName="end" #dateRangeEnd (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                    </mat-date-range-input>
                    <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="campaignOnePicker"></mat-datepicker-toggle>
                    <mat-date-range-picker #campaignOnePicker>
                        <mat-date-range-picker-actions>
                            <button class="apply" mat-raised-button color="primary" matDateRangePickerApply>Apply</button>
                            <button class="can" mat-button matDateRangePickerCancel>Cancel</button>
                        </mat-date-range-picker-actions>
                    </mat-date-range-picker>
                </mat-form-field>
            </div>
        </div>
        
        

        <ul class="listcont">
   
            <li class="pointer" (click)="changeTabName('totalLeads')">
                Total Leads
                <span class="orenge">{{performanceDetails?.totalLeads | number}}</span>
            </li>
            <li class="pointer" (click)="changeTabName('newLeads')">
                New Leads
                <span class="green">{{performanceDetails?.newLeads | number}}</span>
            </li>
            <li class="pointer" (click)="changeTabName('activeLeads')">
                Active Leads
                <span class="orenge">{{performanceDetails?.activeLeads | number}}</span>
            </li>
            <li class="pointer" (click)="changeTabName('badLeads')">
                Bad Leads
                <span class="red">{{performanceDetails?.badLeads | number}}</span>
            </li>
            <li class="pointer" (click)="changeTabName('closedLeads')">
                Closed Leads
                <span class="purple">{{performanceDetails?.closedLeads | number}}</span>
            </li>
            <li class="pointer" (click)="changeTabName('duplicateLeads')">
                Duplicate Leads
                <span class="red">{{performanceDetails?.duplicateLeads | number}}</span>
            </li>
            <li class="pointer" (click)="changeTabName('uniqueLeads')">
                Unique Leads
                <span class="blue">{{performanceDetails?.uniqueLeads | number}}</span>
            </li>
            <li class="pointer">
                Gain Or Loss
                <span class="blue">$ {{performanceDetails?.gainOrLoss | number}}</span>
            </li>
            <li class="pointer">
                Performance
                <span class="blue">{{performanceDetails?.performance | number}} %</span>
            </li>
            <li class="pointer">
                Charge Back
                <span class="blue">{{performanceDetails?.chargeBack | number}} %</span>
            </li>
            <li class="pointer">
                Contact Rate
                <span class="blue">{{performanceDetails?.contactRate | number}} %</span>
            </li>
            <li class="pointer">
                CTL Conversion Rate
                <span class="blue">{{performanceDetails?.ctlConversionRate | number}} %</span>
            </li>
            <li class="pointer">
                LTS Conversion Rate
                <span class="blue">{{performanceDetails?.ltsConversionRate | number}} %</span>
            </li>
            <li class="pointer">
                Ctr
                <span class="blue">{{performanceDetails?.ctr | number}}</span>
            </li>
            <li class="pointer">
                Ehw Epc
                <span class="blue">{{performanceDetails?.ehwEpc | number}} %</span>
            </li>
            <li class="pointer">
                Partner Epc
                <span class="blue">{{performanceDetails?.partnerEpc | number}}</span>
            </li>
            <li class="pointer" (click)="changeTabName('uniqueClicks')">
                Unique Clicks
                <span class="blue">{{performanceDetails?.uniqueClicks | number}}</span>
            </li>
            <li class="pointer" (click)="changeTabName('totalClicks')">
                Total Clicks
                <span class="blue">{{performanceDetails?.totalClicks | number}}</span>
            </li>
            <li class="pointer" (click)="changeTabName('refund')">
                Refund
                <span class="blue">{{performanceDetails?.refund | number}}</span>
            </li>
            <li class="pointer">
                Return Of Investment
                <span class="blue">{{performanceDetails?.returnOfInvestment | number}} %</span>
            </li>
            <li class="pointer">
                Revenues
                <span class="blue">$ {{performanceDetails?.revenues | number}}</span>
            </li>
            <li class="pointer" (click)="changeTabName('leadsNetCost')">
                Leads Net Cost
                <span class="green">$ {{performanceDetails?.leadsNetCost | number}}</span>
            </li>
            <li class="pointer" (click)="changeTabName('totalLeadsCost')">
                Total Leads Cost
                <span class="green">$ {{performanceDetails?.totalLeadsCost | number}}</span>
            </li>
        </ul>
    </div>

    <div class="tablewrapper" *ngIf="listDetails?.leadData">

        <fury-page-layout-header>
            <fury-breadcrumbs [@fadeInRight]  current="performance details"></fury-breadcrumbs>
          </fury-page-layout-header>
        <fury-page-layout-content [@fadeInUp]>
        <fury-list name={{listDetails?.listTitle}} [columns]="leadColumns" (filterChange)="onFilterChange($event)">
            <div style="position: relative;" class="filter">
                <button class="filter fury-column-filter" type="button" mat-icon-button (click)="showFilter()">
                  <img src="../../../assets/img/filter.png" alt="filter"/>
                </button>
                <div class="filteringprt" *ngIf="isShowFilter">
                  <form [formGroup]="filterForm">
                  <h3 style="margin: 0;">Filter</h3>
                  <mat-form-field appearance="outline">
                    <mat-label>Search By</mat-label>
                    <mat-select formControlName="searchBy">
                      <mat-option *ngFor="let item of serchByValue" [value]="item?.value">{{item.title}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Search Type</mat-label>
                    <mat-select formControlName="searchType">
                      <mat-option *ngFor="let item of commonService.searchTypeValue" [value]="item?.value">{{item.title}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div class="btnprt">
                    <button mat-button class="can-button" (click)="showFilter()">Cancel</button>
                    <button mat-button class="sub-button" (click)="filterChange()">Search</button>
                  </div>
                </form>
                </div>
              </div>
            <table [dataSource]="leadList" mat-table>
              
                <ng-container matColumnDef="firstName">
                    <th mat-header-cell *matHeaderCellDef>First Name</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.firstName}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="lastName">
                    <th mat-header-cell *matHeaderCellDef>Last Name</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.lastName}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="emailAddress">
                    <th mat-header-cell *matHeaderCellDef>Email Address</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.emailAddress}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="source">
                    <th mat-header-cell *matHeaderCellDef>Source</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.source}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="soldAmount">
                    <th mat-header-cell *matHeaderCellDef>Sold Amount</th>
                    <td mat-cell *matCellDef="let element">
                        $ {{(element?.soldAmount | number) || 0}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="attempts">
                    <th mat-header-cell *matHeaderCellDef>Attempts</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.attempts || 0}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="address">
                    <th mat-header-cell *matHeaderCellDef>Address</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.address?.streetAddress}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="city">
                    <th mat-header-cell *matHeaderCellDef>City</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.address?.city}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="zip">
                    <th mat-header-cell *matHeaderCellDef>Zip</th>
                    <td mat-cell *matCellDef="let element">
                        {{element.address?.zip}}
                    </td>
                </ng-container>
                 
                <tr *matHeaderRowDef="leadVisibleColumns" mat-header-row></tr>
                <tr *matRowDef="let row; columns: leadVisibleColumns"
                    class="clickable route-animations-elements" mat-row>
                </tr>
            </table>
            <div *ngIf="leadList?.length === 0" style="padding: 10px 0; text-align:center;">
                No data found.
            </div>
            <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount" [pageIndex]="pageIndex" (page)="pageSizeChange($event)"
                showFirstLastButtons
                [selectConfig] = "selectConfig"
                [ngClass]="{'mat-pegig': leadList === 9999}"
                aria-label="Select page of periodic elements">
            </mat-paginator>  
           
        </fury-list>
    </fury-page-layout-content>
    </div>
    <div class="tablewrapper" *ngIf="listDetails?.analyticData">
        <fury-page-layout-content [@fadeInUp]>
        <fury-list name={{listDetails?.listTitle}} [columns]="columns" (filterChange)="onFilterChange($event)">
            <div style="position: relative;" class="filter">
                <button class="filter fury-column-filter" type="button" mat-icon-button (click)="showFilter()">
                  <img src="../../../assets/img/filter.png" alt="filter"/>
                </button>
                <div class="filteringprt" *ngIf="isShowFilter">
                  <form [formGroup]="filterForm">
                  <h3 style="margin: 0;">Filter</h3>
                  <mat-form-field appearance="outline">
                    <mat-label>Search By</mat-label>
                    <mat-select formControlName="searchBy">
                      <mat-option *ngFor="let item of analyticsSerchByValue" [value]="item?.value">{{item.title}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Search Type</mat-label>
                    <mat-select formControlName="searchType">
                      <mat-option *ngFor="let item of commonService.searchTypeValue" [value]="item?.value">{{item.title}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div class="btnprt">
                    <button mat-button class="can-button" (click)="showFilter()">Cancel</button>
                    <button mat-button class="sub-button" (click)="filterChange()">Search</button>
                  </div>
                </form>
                </div>
              </div>
            <table [dataSource]="itemList" mat-table matSort>

               <ng-container matColumnDef="createdAt">
                    <th mat-header-cell *matHeaderCellDef>Created At</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.createdAt | date : 'MMM-dd-YYYY h:mm a'}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="city">
                    <th mat-header-cell *matHeaderCellDef>City</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.city}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="state">
                    <th mat-header-cell *matHeaderCellDef>State</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.state}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="country">
                    <th mat-header-cell *matHeaderCellDef>Country</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.country}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="browserInfo">
                    <th mat-header-cell *matHeaderCellDef>Browser Info</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.browserInfo}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="osInfo">
                    <th mat-header-cell *matHeaderCellDef>OS Info</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.osInfo}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="ipAddress">
                    <th mat-header-cell *matHeaderCellDef>Ip Address</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.ipAddress}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="utmSource">
                    <th mat-header-cell *matHeaderCellDef>Utm Source</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.utmSource}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="internalUrl">
                    <th mat-header-cell *matHeaderCellDef>Internal Url</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.internalUrl}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="referralUrl">
                    <th mat-header-cell *matHeaderCellDef>Referral Url</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.referralUrl}}
                    </td>
                </ng-container>
                 
                <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
                <tr *matRowDef="let row; columns: visibleColumns"
                    class="clickable route-animations-elements" mat-row>
                </tr>
            </table>
            <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount" [pageIndex]="pageIndex" (page)="pageSizeChange($event)"
                showFirstLastButtons
                [selectConfig] = "selectConfig"
                [ngClass]="{'mat-pegig': pageSize === 9999}"
                aria-label="Select page of periodic elements">
            </mat-paginator>
           
            
            <div *ngIf="itemList?.length === 0" style="padding: 10px 0; text-align:center;">
                No data found.
            </div>
           
        </fury-list>
    </fury-page-layout-content>
    </div>

</div>
</fury-page-layout>
